// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-zoomer[data-v-35945d4e]{overflow:hidden}.zoomer[data-v-35945d4e]{transform-origin:50% 50%;width:100%;height:100%}.zoomer>img[data-v-35945d4e]{vertical-align:top;user-drag:none;-webkit-user-drag:none;-moz-user-drag:none}", ""]);
// Exports
module.exports = exports;
